import React, { FC } from 'react';

import { Box, SxProps } from '@mui/material';

import {
  IAdminBookedPharmacistDetails,
  IAdminRequestData,
  IAdminWorkshiftDetails,
  ICalendarEventType,
  ILongTermContractModel,
  IMatchingAvailabilities,
  IPharmacistEvent,
  PharmacistLegendVariant,
} from '@pharmaplan/common';

import ServiceCard from '../ServiceCard/ServiceCard';
import PharmacyCardContent from './PharmacyCardContent/PharmacyCardContent';
import PharmacyCardFooter from './PharmacyCardFooter/PharmacyCardFooter';
import classes from './PharmacyCardContent/style';

export interface IPharmacyCard {
  type: ICalendarEventType;
  hideBorder?: boolean;
  customContainerStyle?: SxProps;
  event:
    | (Partial<IPharmacistEvent> &
        Partial<
          IAdminWorkshiftDetails | IAdminRequestData | IMatchingAvailabilities
        >)
    | Partial<IAdminBookedPharmacistDetails>;
  successAction: string;
  showPharmacyName?: boolean;
  CustomContent?: React.ReactNode;
  CustomFooter?: React.ReactNode;
  contentClick?: () => void;
  customTitleStyle?: SxProps;
  goBack?: () => void;
  isAutoSyncRecord?: boolean;
  CustomRightItem?: React.ReactNode;
  longTermShiftContract?: ILongTermContractModel;
  isPromoBooking?: boolean;
  discountTooltip?: string;
  showDiscountIcon?: boolean;
}

const PharmacyCard: FC<IPharmacyCard> = ({
  type,
  event,
  successAction,
  customContainerStyle,
  showPharmacyName,
  CustomContent,
  discountTooltip,
  CustomFooter,
  hideBorder = false,
  contentClick = null,
  customTitleStyle,
  goBack,
  isAutoSyncRecord,
  CustomRightItem,
  isPromoBooking,
  showDiscountIcon,
  longTermShiftContract,
}) => {
  const handlePharmacyCard = () => {
    if (contentClick) {
      return (
        <Box component="div" sx={classes.cardHover} onClick={contentClick}>
          <PharmacyCardContent
            discountTooltip={discountTooltip}
            showDiscountIcon={showDiscountIcon}
            successAction={successAction}
            CustomContent={CustomContent}
            type={type}
            event={event}
            showPharmacyName={showPharmacyName}
            customTitleStyle={customTitleStyle}
            isAutoSyncRecord={isAutoSyncRecord}
            CustomRightItem={CustomRightItem}
            longTermShiftContract={longTermShiftContract}
          />
        </Box>
      );
    }

    return (
      <PharmacyCardContent
        successAction={successAction}
        showDiscountIcon={showDiscountIcon}
        CustomContent={CustomContent}
        type={type}
        event={event}
        showPharmacyName={showPharmacyName}
        customTitleStyle={customTitleStyle}
        goBack={goBack}
        isAutoSyncRecord={isAutoSyncRecord}
        CustomRightItem={CustomRightItem}
        longTermShiftContract={longTermShiftContract}
      />
    );
  };

  return (
    <ServiceCard
      isPromoBooking={isPromoBooking}
      customContainerStyle={customContainerStyle}
      eventType={
        hideBorder
          ? null
          : PharmacistLegendVariant[
              type as keyof typeof PharmacistLegendVariant
          ]
      }
      content={handlePharmacyCard()}
      footer={
        CustomFooter ?? (
          <PharmacyCardFooter
            type={type}
            successAction={successAction}
            isPromoBooking={isPromoBooking}
            event={event}
          />
        )
      }
    />
  );
};

export default PharmacyCard;
